RivalIQ.module('behaviors', function (behaviors, Admin, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.Dismissible = Marionette.Behavior.extend({
        initialize: function () {
            const me = this;
            me.dashboardModel = me.view.dashboardModel || _.get(me.view, ['options', 'dashboardModel']);
            me.listenTo(me.dashboardModel, 'dismissed', me.dismissView);
        },

        events: {
            // NOTE do not replace with triggers hash!
            // The default parameter passed to 'onWidgetDismissed' results in
            // serialization of a cyclic structure.
            'click .x-dismiss': 'onDismissClick'
        },

        onDismissClick: function () {
            const me = this;
            me.dashboardModel.dismiss();
        },

        dismissView: function () {
            const me = this;

            me.view.$el.velocity('fadeOut', {
                complete: function () {
                    me.view.destroy();
                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.HidDashboardWidget);
                    me.dashboardModel.trigger('dismissibleDestroyed');
                }
            });
        }
    });
});
